import { commitState, readState } from "../base/state";

export function getCart(storeGuid, skuGuid) {
  let storeCartData = readState("storeCartData", {});
  let cartInfo = undefined;
  (storeCartData[storeGuid] || []).forEach(item => {
    if (item.skuGuid == skuGuid) {
      cartInfo = item;
    }
  });
  return cartInfo;
}

export function removeCart(storeGuid, skuGuid) {
  let storeCartData = readState("storeCartData", {});
  storeCartData[storeGuid] = (storeCartData[storeGuid] || []).filter(item => {
    return item.skuGuid != skuGuid;
  })
  commitState({ storeCartData })
}

export function addCart(storeGuid, skuGuid, skuInfo, countStep = 1) {
  let cartInfo = getCart(storeGuid, skuGuid);
  let replenishCount = countStep;
  if (cartInfo) {
    removeCart(storeGuid, skuGuid);
    replenishCount += cartInfo.replenishCount;
  }
  let storeCartData = readState("storeCartData", {});
  if (replenishCount > 0) {
    if (storeCartData[storeGuid]) {
      storeCartData[storeGuid] = [...storeCartData[storeGuid], {
        skuGuid,
        replenishCount,
        skuInfo
      }]
    } else {
      storeCartData[storeGuid] = [{
        skuGuid,
        replenishCount,
        skuInfo
      }]
    }
  }
  commitState({ storeCartData })
}

export function clearCart(storeGuid) {
  let storeCartData = readState("storeCartData", {});
  storeCartData[storeGuid] = [];
  commitState({ storeCartData })
}
